import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConfirmDeleteDialog = ({ open, onOpenChange, title, description, busy, onConfirm, testid, confirmLabel = "Delete", cancelLabel = "Keep" }) => (
  <AlertDialog open={open} onOpenChange={(o) => !o && !busy && onOpenChange(false)}>
    <AlertDialogContent data-testid={testid}>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testid}-cancel`} disabled={busy}>{cancelLabel}</AlertDialogCancel>
        <AlertDialogAction data-testid={`${testid}-confirm`} disabled={busy} onClick={(e) => { e.preventDefault(); onConfirm(); }}>
          {busy ? "Deleting…" : confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
